export const TAB_KEY = "Tab";

export const ARROW_UP_KEY = "ArrowUp";

export const ARROW_DOWN_KEY = "ArrowDown";

export const ARROW_LEFT_KEY = "ArrowLeft";

export const ARROW_RIGHT_KEY = "ArrowRight";

export const HOME_KEY = "Home";

export const END_KEY = "End";

export const PAGE_UP_KEY = "PageUp";

export const PAGE_DOWN_KEY = "PageDown";

export const BACKSPACE_KEY = "Backspace";

export const DELETE_KEY = "Delete";

export const ENTER_KEY = "Enter";

export const SPACE_KEY = " ";

export const SHIFT_KEY = "Shift";

export const ESCAPE_KEY = "Escape";
